module.exports = __webpack_public_path__ + "static/media/la.7c25dcf0.svg";